import { Directive, ElementRef, forwardRef, HostListener, inject, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const COMMA_DECIMAL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MngCommaDecimalParserDirective),
  multi: true
};

@Directive({
  selector: '[mngCommaDecimalParser]',
  providers: [COMMA_DECIMAL_VALUE_ACCESSOR]
})
export class MngCommaDecimalParserDirective implements ControlValueAccessor {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  @HostListener('change', ['$event.target.value']) onChange = (value: any) => {
    return;
  };

  @HostListener('blur', []) onTouched = () => {
    return;
  };

  @HostListener('input', ['$event.target.value']) onInput = this.onChange;

  writeValue(decimalWithDots: number) {
    // MODEL -> VIEW
    if (decimalWithDots !== undefined && decimalWithDots !== null) {
      const viewValue = decimalWithDots.toString().replace(/\./g, ',');
      this.renderer.setProperty(this.elementRef.nativeElement, 'value', viewValue);
    }
  }

  registerOnChange(fn: (_: any) => void) {
    // VIEW -> MODEL
    this.onChange = (decimalWithCommas) => {
      fn(decimalWithCommas ? Number(decimalWithCommas.replace(/,/g, '.')) : null);
    };
    this.onInput = this.onChange;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }
}
